export default __webpack_public_path__ + "static/media/M_wdt_c_cap_2.47bf8a9f.mp3";